import { render, staticRenderFns } from "./DetailProductOther.vue?vue&type=template&id=a2e762b6&"
import script from "./DetailProductOther.vue?vue&type=script&lang=js&"
export * from "./DetailProductOther.vue?vue&type=script&lang=js&"
import style0 from "./DetailProductOther.vue?vue&type=style&index=0&id=a2e762b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports